import React from 'react';

export const ComponentToPrint = React.forwardRef(({ children }, ref) => {
  const getPageMargins = () => {
    return `@page { margin: ${'20px'} ${'20px'} ${'20px'} ${'20px'} !important; }`;
  };

  return (
    <div ref={ref}>
      <style>{getPageMargins()}</style>
      {children}
    </div>
  );
});
